import React from 'react';
import { AdminNav } from '../../components';

const AdminDashboard = () => {
    // const { user } = useSelector((state) => ({ ...state }));
    // const history = useHistory()
    // const [loading, setLoading] = useState(false)

    return (<div className="admin-dashboard">
        {/* {
            loading ? <h1>Loading</h1> : ( */}
        <div className="row">
            <div className="col-md-2">
                <AdminNav />
            </div>
            <div className="col-md-7">
                <h1>Sent invites</h1>
            </div>
            <div className="col-md-3">
                <h1>Accepted</h1>
            </div>
        </div>
        {/* )
        } */}
    </div>)
};

export default AdminDashboard;